import { forEach, values, sortBy } from "lodash";
import moment from "moment";
import { systemtheme } from "orcs-design-system";
import { DEFAULT_DATE_FORMAT } from "src/consts/global";
import { getStartDate, getEndDate } from "src/util/memberships";
import { numberToLocaleString } from "src/util/toLocaleString";
import { addTotalItemStatus } from "src/util/membershipTimeline";

const itemStyles = {
  style: `
    background-color: ${systemtheme.colors.primary};
    color: ${systemtheme.colors.white};
    border-radius: ${systemtheme.radii[2]};
    border: solid 1px ${systemtheme.colors.white};
    font-size: ${systemtheme.fontSizes[0]};
    font-weight: ${systemtheme.fontWeights[2]};
    padding: ${systemtheme.space.xs} ${systemtheme.space.s};
  `,
};

export const convertMemberships = (memberships, person, fteConfig) => {
  const items = [];
  const allGroups = {};
  const allDates = [];
  const numberDecimal = {
    decimalplaces: fteConfig.decimal,
  };

  forEach(memberships, (membership) => {
    const { groupId, group, startDate, endDate, attributes } = membership;
    const { fte = 1 } = attributes || {};

    allGroups[groupId] = {
      id: groupId,
      content: group.name,
      group,
    };

    const start = getStartDate(startDate);
    const end = getEndDate(endDate);
    const content = `${numberToLocaleString(fte, numberDecimal)} FTE`;
    const title = `${content} from ${moment(startDate).format(
      DEFAULT_DATE_FORMAT
    )} ${
      endDate ? `to ${moment(endDate).format(DEFAULT_DATE_FORMAT)}` : "Ongoing"
    }`;

    items.push({
      start,
      end,
      content,
      title,
      group: groupId,
      fte,
      align: "auto",
      ...itemStyles,
    });

    allDates.push(start, end);
  });

  const groups = sortBy(values(allGroups), "content");

  addTotalItemStatus({
    groups,
    allDates,
    items,
    personFte: person.fte,
    numberDecimal,
  });

  return { items, groups };
};

export const getGroupContainerId = (group) => {
  return `group-container-${group.id}`;
};
